import axios from 'axios';

const registraAcesso = ((idEncoded, data) => axios.post(`/external/solicitacao/${idEncoded}/acessos`, data));
const registraAcessoCompra = ((idEncoded, data) => axios.post(`/external/pedidos/${idEncoded}/acessos`, data));

export default {
  registraAcesso,
  registraAcessoCompra,
};
